export default "__VITE_ASSET__CQTahxyX__"